module.exports = __webpack_public_path__ + "img/Hover_KasPro_Bank.0be3293b.png";